export { AlternateOrderValidationWarning } from 'quotes/enums';

export enum AlternateOrderPartValidationWarning {
  DISALLOWED_MANUFACTURER = 'disallowed_manufacturer',
  EXTERNAL_PART_STATUS_ABANDONED = 'external_part_status_abandoned',
  INVALID_QUANTITY_DECIMAL = 'invalid_quantity_decimal',
  MISSING_COST = 'missing_cost',
  MISSING_DESCRIPTION = 'missing_description',
  MISSING_MANUFACTURER = 'missing_manufacturer',
  MISSING_ONE_TIME_SPA_VALID_UNTIL = 'missing_one_time_spa_valid_until',
  MISSING_PRICE = 'missing_price',
  MISSING_REPLACEMENT_COST = 'missing_replacement_cost',
  MISSING_REPLACEMENT_COST_NUMBER = 'missing_replacement_cost_number',
  MISSING_SHIPMENT_TYPE = 'missing_shipment_type',
  MISSING_SHIPPING_LOCATION = 'missing_shipping_location',
  MISSING_TAXONOMY = 'missing_taxonomy',
  MISSING_VENDOR = 'missing_vendor',
  MISSING_VENDOR_QUOTE_NUMBER = 'missing_vendor_quote_number',
  NOTE_BUYER_TOO_LONG = 'note_buyer_too_long',
  NOTE_PICKER_TOO_LONG = 'note_picker_too_long',
  NOTE_SUPSHIP_TOO_LONG = 'note_supship_too_long',
  PART_NUMBER_TOO_LONG = 'part_number_too_long',
  PAST_ONE_TIME_SPA_VALID_UNTIL = 'past_one_time_spa_valid_until',
  WRONG_SHIPPING_LOCATION_TYPE = 'wrong_shipping_location_type',
}
